import { gql } from '@apollo/client';

export default gql`
  query ($listingId: String) {
    user {
      userId
      emailAddress
      listings(listingId: $listingId) {
        title
        listingId
        location
        urlKey
        enquiries {
          userId
          enquiryId
          listingId
          name
          emailAddress
          message
          phoneCountryCode
          phoneNumber
          lastUpdated
        }
      }
    }
  }
`;
